module.exports = __webpack_public_path__ + "static/media/access_banner_mobile.6dc57b1e.png";